import { render, staticRenderFns } from "./subpackage-input-fields.vue?vue&type=template&id=1982f90c&"
import script from "./subpackage-input-fields.vue?vue&type=script&lang=js&"
export * from "./subpackage-input-fields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports